import React from "react";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Search } from "lucide-react";
import { SECTORS, STAGES, PRIORITY } from "../../lib/constants";

const STAGE_LABELS = Object.fromEntries(STAGES.map((s) => [s.key, s.label]));
const STAGE_KEYS = STAGES.map((s) => s.key);
const PRIORITY_KEYS = Object.keys(PRIORITY);

export const DatabaseFilters = ({ filters, onChange }) => (
  <div className="flex flex-wrap gap-3">
    <div className="relative flex-1 min-w-[220px]">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input placeholder="Cerca azienda, città, referente..." value={filters.q} onChange={(e) => onChange("q", e.target.value)} className="pl-9" data-testid="search-input" />
    </div>
    <FilterSelect value={filters.sector} onChange={(v) => onChange("sector", v)} placeholder="Settore" options={SECTORS} testid="filter-sector" />
    <FilterSelect value={filters.priority} onChange={(v) => onChange("priority", v)} placeholder="Priorità" options={PRIORITY_KEYS} testid="filter-priority" />
    <FilterSelect value={filters.status} onChange={(v) => onChange("status", v)} placeholder="Stato" options={STAGE_KEYS} labels={STAGE_LABELS} testid="filter-status" />
  </div>
);

export const applyFilters = (prospects, f) => {
  const list = prospects.filter((p) => {
    if (f.q && !`${p.azienda} ${p.citta} ${p.referente}`.toLowerCase().includes(f.q.toLowerCase())) return false;
    if (f.sector !== "all" && p.settore !== f.sector) return false;
    if (f.priority !== "all" && p.priority !== f.priority) return false;
    if (f.status !== "all" && p.status !== f.status) return false;
    return true;
  });
  return list.sort((a, b) => (f.sortDesc ? b.priority_score - a.priority_score : a.priority_score - b.priority_score));
};

function FilterSelect({ value, onChange, placeholder, options, labels, testid }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-40" data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Tutti</SelectItem>
        {options.map((o) => <SelectItem key={o} value={o}>{labels ? labels[o] : o}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
